<template>
<div class="chapter">
<div class="inner_page">
<div id="toc" style="font-weight:bold"><h1 id="toc-title">Spurious Conversations with Ghosts</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#dedication">Dedication</a></li>
<li id="toc-li-2"><a href="#/text/ch002#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-3"><a href="#/text/ch003#january-2000-eastbourne">January 2000, Eastbourne</a></li>
<li id="toc-li-4"><a href="#/text/ch004#february-2018-hever-castle">February 2018, Hever Castle</a></li>
<li id="toc-li-5"><span href="#/text/ch005#march-2022-brighton" title="Link target outside of Sample">March 2022, Brighton</span></li>
<li id="toc-li-6"><span href="#/text/ch006#april-2014-beachy-head" title="Link target outside of Sample">April 2014, Beachy Head</span></li>
<li id="toc-li-7"><span href="#/text/ch007#may-2015-leicester-cathedral" title="Link target outside of Sample">May 2015, Leicester Cathedral</span></li>
<li id="toc-li-8"><span href="#/text/ch008#june-2020-hastings-old-town" title="Link target outside of Sample">June 2020, Hastings Old Town</span></li>
<li id="toc-li-9"><span href="#/text/ch009#july-2022-m-40-motorway-oxfordshire" title="Link target outside of Sample">July 2022, M 40 Motorway, Oxfordshire</span></li>
<li id="toc-li-10"><span href="#/text/ch010#august-2018-hever-castle" title="Link target outside of Sample">August 2018, Hever Castle</span></li>
<li id="toc-li-11"><span href="#/text/ch011#september-1996-bodiam-castle" title="Link target outside of Sample">September 1996, Bodiam Castle</span></li>
<li id="toc-li-12"><span href="#/text/ch012#october-2016-battle-abbey" title="Link target outside of Sample">October 2016, Battle Abbey</span></li>
<li id="toc-li-13"><span href="#/text/ch013#november-2002-caldwell-manor" title="Link target outside of Sample">November 2002, Caldwell Manor</span></li>
<li id="toc-li-14"><span href="#/text/ch014#december-2018-ightham-mote" title="Link target outside of Sample">December 2018, Ightham Mote</span></li>
<li id="toc-li-15"><span href="#/text/ch015#survival-city-no.-22-england" title="Link target outside of Sample">2084, Survival City No. 22, England</span></li>
<li id="toc-li-16"><span href="#/text/ch016#acknowledgement" title="Link target outside of Sample">Acknowledgement</span></li>
<li id="toc-li-17"><span href="#/text/ch017#about-the-author" title="Link target outside of Sample">About the Author</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?208f91bc